/* ============================================================
   KenetikPro Lander JS
   Lightweight, no dependencies.
   1. Role-selector conditional fieldsets for the lead form.
   2. Optional GA / GTM tracking hook via [data-pro-track].
   ============================================================ */
(function () {
  'use strict';

  function initRoleSelector(root) {
    var select = root.querySelector('[data-pro-role-select]');
    if (!select) return;

    var branches = root.querySelectorAll('[data-pro-branch]');

    function applyBranch(role) {
      branches.forEach(function (branch) {
        var match = branch.getAttribute('data-pro-branch') === role;
        branch.classList.toggle('active', match);

        // Toggle required attributes on conditionally-required fields.
        var conditional = branch.querySelectorAll('[data-pro-conditional-required]');
        conditional.forEach(function (field) {
          var requiredFor = field.getAttribute('data-pro-conditional-required');
          if (requiredFor === role) {
            field.setAttribute('required', 'required');
          } else {
            field.removeAttribute('required');
          }
        });
      });
    }

    select.addEventListener('change', function () {
      applyBranch(select.value);
    });

    // Initial state — in case the select is pre-populated by browser autofill.
    if (select.value) applyBranch(select.value);
  }

  function initTrackingHooks() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-pro-track]');
      if (!el) return;
      var name = el.getAttribute('data-pro-track');
      if (!name) return;
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, { event_category: 'kenetik_pro_lander' });
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: name, lander: 'kenetik-pro' });
      }
    });

    // Form-submit tracking.
    var form = document.getElementById('ks-wholesale-contact-form');
    if (form) {
      form.addEventListener('submit', function () {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'pro_form_submit', { event_category: 'kenetik_pro_lander' });
        }
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({ event: 'pro_form_submit', lander: 'kenetik-pro' });
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('.ks-wholesale').forEach(initRoleSelector);
    initTrackingHooks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
